export const convertPrice = (priceAED, target, rates = { AED: 1, USD: 0.272, IQD: 356.6 }) => {
  const rate = rates[target] ?? 1;
  const val = priceAED * rate;
  if (target === "IQD") return Math.round(val).toLocaleString();
  if (target === "USD") return val.toFixed(2);
  return val.toFixed(0);
};

export const formatPrice = (priceAED, currency, settings) => {
  const rates = {
    AED: 1,
    USD: settings?.rate_usd ?? 0.272,
    IQD: settings?.rate_iqd ?? 356.6,
  };
  return `${convertPrice(priceAED, currency, rates)} ${currency}`;
};
